import HeaderImage from "../img/myked_header_850.png";
import Navbar from "react-bootstrap/Navbar";

export default function Header({ activeSection = 'home' }) {
  return (
    <header>
      <Navbar bg="light" fixed="top" id="navbar" className="m-0 p-0">
        <nav
          style={{ justifyContent: "center" }}
          className="navbar navbar-expand-lg"
        >
          <a className="navbar-brand p-3" href="#home">
            <img src={HeaderImage} className="img-responsive" alt="Myke D - Creative Developer & Game Designer Portfolio Header" />
          </a>

          <ul
            style={{ justifyContent: "center" }}
            className="navbar-nav mr-auto mt-2 mt-lg-0"
          >
            <li className="nav-item">
              <a 
                className={`nav-link ${activeSection === 'home' ? 'active-scroll-spy' : ''}`} 
                href="#home"
              >
                Home
              </a>
            </li>
            <li className="nav-item">
              <a
                className={`nav-link ${activeSection === 'about' ? 'active-scroll-spy' : ''}`}
                href="#about"
              >
                About
              </a>
            </li>
            <li className="nav-item">
              <a
                className={`nav-link ${activeSection === 'projects' ? 'active-scroll-spy' : ''}`}
                href="#projects"
              >
                Projects
              </a>
            </li>
            <li className="nav-item">
              <a
                className={`nav-link ${activeSection === 'contact' ? 'active-scroll-spy' : ''}`}
                href="#contact"
              >
                Contact
              </a>
            </li>
          </ul>
        </nav>
      </Navbar>
    </header>
  );
}
